// ADDED by MADEV d070825 to exclude certain vendors from Brand filters -->
document.addEventListener('DOMContentLoaded', function () {
  const isCollectionPage = window.location.pathname.includes('/collections/');
  const isSearchPage = window.location.pathname.includes('/search');

  if (!(isCollectionPage || isSearchPage)) return;

  const excludedVendors = ["F4NTEC", "Airstrike", "Bless My Sole®", "So God Made A Farmer®" ];

  const hideUnwantedVendorFilters = () => {
    document.querySelectorAll('label.facet-checkbox').forEach(label => {
      const labelText = label.childNodes[0]?.textContent?.trim()?.toLowerCase();
      if (labelText) {
        excludedVendors.forEach(vendor => {
          if (labelText === vendor.toLowerCase()) {
            const parentItem = label.closest('li.facets__item');
            if (parentItem) parentItem.remove();
          }
        });
      }
    });
  };

  hideUnwantedVendorFilters();
  document.addEventListener('shopify:section:load', hideUnwantedVendorFilters);
  setTimeout(hideUnwantedVendorFilters, 1000);
});

// ADDED by MADEV: hide #ps__widget_container while Avada cookie bar is visible; show after accept/decline/close.
// Wholesale page always hides the widget. Apps inject late — MutationObserver keeps state in sync.
(function () {
  const WHOLESALE_PATH = '/pages/become-a-kerusso-retailer';
  const AVADA_COOKIE_BAR_ID = 'Avada-CookiesBar';

  function isWholesalePage() {
    return window.location.pathname === WHOLESALE_PATH;
  }

  function isAvadaCookieBarVisible() {
    const el = document.getElementById(AVADA_COOKIE_BAR_ID);
    if (!el) return false;
    if (el.hidden) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    const cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) {
      return false;
    }
    const rect = el.getBoundingClientRect();
    if (rect.width < 1 && rect.height < 1) return false;
    return true;
  }

  function shouldHidePsWidget() {
    if (isWholesalePage()) return true;
    return isAvadaCookieBarVisible();
  }

  function syncPsWidgetVisibility() {
    document.documentElement.classList.toggle(
      'madev-ps-widget-hidden-for-cookie',
      shouldHidePsWidget()
    );
  }

  function setup() {
    syncPsWidgetVisibility();
    const root = document.body || document.documentElement;
    const observer = new MutationObserver(syncPsWidgetVisibility);
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

document.addEventListener('click', (e) => {
  const a = e.target.closest('a[data-mega-parent-link]');
  if (!a) return;

  // Stop the click from toggling the <details>/<summary>
  e.stopPropagation();
});

// move lb-tryon-trigger-btn-block to add to cart
(function () {
  const TRYON_SELECTOR = '.lb-tryon-trigger-btn-block';
  const MOBILE_QUERY = '(max-width: 749px)';
  let originalParent = null;
  let originalNextSibling = null;

  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  function getTargetContainer() {
    const containers = document.querySelectorAll('.product-form__buttons .add-to-cart-button-container');
    for (const container of containers) {
      if (!container.closest('sticky-atc')) return container;
    }
    return containers[0] || null;
  }

  function updateEmptyState(trigger) {
    // app markup leaves whitespace text nodes, so CSS :empty never matches; check real content instead
    const isEmpty = trigger.children.length === 0 && trigger.textContent.trim() === '';
    trigger.classList.toggle('is-empty', isEmpty);
  }

  function syncTryonButton(isMobile) {
    const trigger = document.querySelector(TRYON_SELECTOR);
    if (!trigger) return;
    updateEmptyState(trigger);

    if (!isMobile) {
      if (originalParent && trigger.parentElement !== originalParent) {
        originalParent.insertBefore(trigger, originalNextSibling);
      }
      return;
    }

    const target = getTargetContainer();
    if (!target || trigger.parentElement === target) return;
    if (!originalParent) {
      originalParent = trigger.parentElement;
      originalNextSibling = trigger.nextSibling;
    }
    target.appendChild(trigger);
  }

  function setup() {
    if (!isProductPage()) return;
    const mql = window.matchMedia(MOBILE_QUERY);
    const run = () => syncTryonButton(mql.matches);
    run();
    const observer = new MutationObserver(run);
    observer.observe(document.body, { childList: true, subtree: true });
    mql.addEventListener('change', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

// move "All sizes are available!" to inventory
(function () {
  const MOBILE_QUERY = '(max-width: 749px)';
  let originalParent = null;
  let originalNextSibling = null;

  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  function syncFloatNotice(isMobile) {
    const notice = document.querySelector('.float-notice');
    const target = document.querySelector('.product-inventory');
    if (!notice || !target) return;

    if (!isMobile) {
      if (originalParent && notice.parentElement !== originalParent) {
        originalParent.insertBefore(notice, originalNextSibling);
      }
      return;
    }

    if (notice.parentElement === target) return;
    if (!originalParent) {
      originalParent = notice.parentElement;
      originalNextSibling = notice.nextSibling;
    }
    target.appendChild(notice);
  }

  function setup() {
    if (!isProductPage()) return;
    const mql = window.matchMedia(MOBILE_QUERY);
    const run = () => syncFloatNotice(mql.matches);
    run();
    mql.addEventListener('change', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
